import Typography from '@mui/material/Typography';
import CollapsibleFrame from '../../components/CollapsibleFrame';
import { CollapsibleTable } from "../../components/CollapsibleTable";
import { MainContainer } from '../../components/MainContainerComp';
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { CurrentRatingsDataAutomation, DroppedRatingsDataAutomation, IRatingsData } from "./RatingsData";
import { collapsibleFrameStyles, footerStyles, tableHeaderStyles } from "./styled";

export const Ratings = ({
  data: { currentRatings, droppedRatings }
}: {
  data: IRatingsData
}) => {
  return (
    <MainContainer hasGreyBg>
      <CollapsibleFrame
        openByDefault
        sx={collapsibleFrameStyles}
        title={
          <Typography data-automation="current-ratings-title" sx={tableHeaderStyles}>
            Current Ratings ({currentRatings.length})
          </Typography>
        }
      >
        <Typography 
          component={'div'} 
          variant='container' 
          data-automation="data-container"
        >
          <ScrollIndicatorsComp>
            <CollapsibleTable
              dataAutomation={CurrentRatingsDataAutomation}
              cols={[{ title: 'Description' }, { title: 'Effective Date' }, { title: 'Trade Certification Date' }]}
              rows={currentRatings.map(({ ratingDescription, ratingEffectiveDate, transactions, tradeCertificationDate = '' }) => ({
                ratingDescription,
                transaction: ratingEffectiveDate ?? '',
                tradeCertificationDate,
                transactions: transactions.map((item) =>
                  ({ type: item.transactionType, date: item.effectiveDate, tradeDate: '' })),
              }))}
            />
          </ScrollIndicatorsComp>
        </Typography>
      </CollapsibleFrame>
      <CollapsibleFrame
        openByDefault
        sx={collapsibleFrameStyles}
        title={
          <Typography data-automation="dropped-ratings-title" sx={tableHeaderStyles}>
            Dropped Ratings ({droppedRatings.length})
          </Typography>
        }
      >
        <Typography 
          component={'div'} 
          variant='container' 
          data-automation="data-container"
        >
          <ScrollIndicatorsComp>
            <CollapsibleTable
              dataAutomation={DroppedRatingsDataAutomation}
              cols={[{ title: 'Description' }, { title: 'Transaction Date' }]}
              rows={droppedRatings.map(({ ratingDescription, transactions }) => ({
                ratingDescription,
                transaction: transactions[0] ? transactions[0].effectiveDate : '',
                transactions: transactions.map((item) => ({ type: item.transactionType, date: item.effectiveDate })),
              }))}
            />
          </ScrollIndicatorsComp>
        </Typography>
      </CollapsibleFrame>
      <Typography data-automation="ratings-label" sx={footerStyles}>
        (*) Rating has been posted on this date, the Effective date is unknown.
      </Typography>
    </MainContainer>
  )
}